var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 29,
    viewBox: "0 0 90 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.936,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6744 0C82.7939 0.00502633 87.8596 3.94715 89.8712 11.8267C90.7576 20.4894 87.0691 26.0577 78.8056 28.5318C69.9221 29.2893 64.5613 25.2978 62.7235 16.5573C62.1741 7.69029 66.1577 2.17108 74.6744 0ZM74.3793 5.322C80.17 4.8649 83.4652 7.5259 84.2646 13.305C84.5464 16.9293 83.3168 19.9353 80.5761 22.3228C74.6266 24.8869 70.643 23.0635 68.6252 16.853C67.6703 11.4586 69.5884 7.61489 74.3793 5.322Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.967,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8711 0.295658C28.7399 0.295658 30.6089 0.295658 32.4777 0.295658C32.4777 9.65853 32.4777 19.0211 32.4777 28.384C30.6089 28.384 28.7399 28.384 26.8711 28.384C26.8711 19.0211 26.8711 9.65853 26.8711 0.295658Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.954,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0842 0.295651C42.905 0.246275 47.7246 0.295651 52.5433 0.443484C57.0731 1.87983 59.4338 4.98433 59.6253 9.75698C59.6318 13.5436 57.9596 16.254 54.6089 17.8878C56.6373 21.3125 58.7029 24.7127 60.8057 28.0883C58.7472 28.4325 56.6816 28.4818 54.6089 28.2361C52.6664 25.3295 50.7973 22.3728 49.0023 19.3661C47.2345 19.2186 45.464 19.1692 43.6908 19.2183C43.6908 22.2734 43.6908 25.3289 43.6908 28.384C41.8221 28.384 39.953 28.384 38.0842 28.384C38.0842 19.0211 38.0842 9.65853 38.0842 0.295651ZM43.6908 5.32198C46.1518 5.2729 48.6107 5.32198 51.0679 5.46982C53.6758 7.00137 54.4136 9.21887 53.281 12.1223C52.9367 12.8615 52.3958 13.4034 51.6581 13.7485C49.0265 14.1666 46.3708 14.3144 43.6908 14.192C43.6908 11.2353 43.6908 8.27865 43.6908 5.32198Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.843,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0184344 0.591339C0.608601 0.591339 1.19877 0.591339 1.78894 0.591339C1.83821 8.18081 1.78894 15.7694 1.64139 23.3577C1.14949 24.3431 0.657792 25.3289 0.165976 26.3143C0.0184344 17.7406 -0.0307265 9.16626 0.0184344 0.591339Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.745,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.67425 0.591321C3.35058 0.51563 3.99002 0.614087 4.59229 0.886987C4.78911 6.70186 4.78911 12.5164 4.59229 18.3313C3.92894 19.1675 3.33877 20.0545 2.82179 20.9923C2.67425 14.1926 2.62497 7.39224 2.67425 0.591321Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.731,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33001 0.591321C6.00634 0.51563 6.64578 0.614087 7.24805 0.886987C7.44487 5.02632 7.44487 9.16565 7.24805 13.305C6.5847 14.1411 5.99454 15.0281 5.47755 15.966C5.33001 10.8421 5.28073 5.71729 5.33001 0.591321Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0676 0.591334C15.7315 0.497017 16.3217 0.64485 16.8381 1.03483C11.7582 10.1789 6.79107 19.394 1.93635 28.6797C1.33409 28.9526 0.694789 29.051 0.0183105 28.9753C4.7246 19.3472 9.74102 9.88591 15.0676 0.591334Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.847,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4285 0.591331C18.1877 0.487256 18.8762 0.635089 19.4941 1.03483C14.4142 10.1789 9.44707 19.394 4.59236 28.6797C3.96118 29.0549 3.32202 29.0549 2.67432 28.6797C7.6751 19.3478 12.5933 9.98496 17.4285 0.591331Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.851,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3792 0.591331C21.1384 0.487256 21.8269 0.635089 22.4448 1.03483C17.3649 10.1789 12.3978 19.394 7.54304 28.6797C6.94078 28.9526 6.30133 29.051 5.625 28.9753C5.70025 28.2314 5.94635 27.5413 6.36271 26.9057C11.1888 18.2202 15.8609 9.44862 20.3792 0.591331Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.853,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3625 15.966C17.7899 20.1379 20.1505 24.3756 22.4445 28.6797C21.6968 29.0572 20.9591 29.0572 20.2314 28.6797C18.3626 25.1317 16.4936 21.5837 14.6248 18.0357C14.5313 17.2353 14.7771 16.5455 15.3625 15.966Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.857,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8871 18.627C14.2958 18.9445 14.6399 19.3387 14.9199 19.8097C16.5039 22.7297 18.0286 25.6863 19.4937 28.6796C18.9269 29.017 18.3367 29.0664 17.7232 28.8275C16.2596 26.2395 14.8332 23.6276 13.4445 20.9923C13.2326 20.1328 13.3802 19.3443 13.8871 18.627Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.851,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5166 21.288C13.087 21.6256 13.5297 22.1182 13.8445 22.7663C14.8021 24.7839 15.8349 26.7552 16.9429 28.6797C16.2545 29.0738 15.5657 29.0738 14.8773 28.6797C14.018 26.8589 13.0835 25.0849 12.074 23.3577C11.8943 22.5993 12.0418 21.9092 12.5166 21.288Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/LoginLogo.0fd014f3120cd7d796023acfb916f181.svg";
export { ForwardRef as ReactComponent };